import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _getIterator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/get-iterator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ========= import plugins =============
import axios from '~/plugins/axios.js';
import domain from '~/plugins/domain.js';

// ========= import components ===========
import SearchModuleSessionForm from '~/components/dashboard/SearchModuleSessionForm';
import SearchModuleSessionOfDay from '~/components/dashboard/SearchModuleSessionOfDay.vue';
import ViewSessionDetailsOfDay from '~/components/dashboard/viewingInfo/ViewSessionDetailsOfDay.vue';

export default {
  name: 'ViewSessionDetails',
  components: {
    SearchModuleSessionForm: SearchModuleSessionForm,
    SearchModuleSessionOfDay: SearchModuleSessionOfDay,
    ViewSessionDetailsOfDay: ViewSessionDetailsOfDay
  },
  data: function data() {
    return {
      moduleSessionReturned: null,
      viewDetailedList: [{
        viewPendingUploadFile: null,
        viewPendingAttend: null
      }],
      moduleSessionCollection: {},
      applicantCollection: {},
      tableFields: {
        viewPendingUploadFile: {
          key: 'viewPendingUploadFile',
          label: 'Pending Upload File'
        },

        viewPendingAttend: {
          key: 'viewPendingAttend',
          label: 'Pending Attend'
        }
      }
    };
  },

  methods: {
    searchModuleSession: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchKey) {
        var searchResult, viewPendingUploadFile, viewPendingAttend, moduleSession, managers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, m, userActorId, msStatusId, msStatusCode, user, _user;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ======== ViewSessionDetails.vue - MS Search keys: ==========\n language: ', searchKey.language, '\n moduleName :', searchKey.moduleName, '\n roomId: ', searchKey.roomId, '\n moduleSessionTime: ', searchKey.moduleSessionTime, '\n ===============');

                _context.next = 3;
                return axios.post('/moduleSession/queryList', searchKey);

              case 3:
                searchResult = _context.sent.data;

                if (!searchResult) {
                  _context.next = 60;
                  break;
                }

                if (!searchResult.hasOwnProperty('moduleSession')) {
                  _context.next = 57;
                  break;
                }

                viewPendingUploadFile = [], viewPendingAttend = [];
                moduleSession = searchResult.moduleSession, managers = searchResult.managers;

                this.moduleSessionReturned = moduleSession;
                console.log('\n\n ===========ViewSessionDetails.vue SearchRes 2==========\n', searchResult, '\n ===========');

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 13;
                _iterator = _getIterator(managers);

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 38;
                  break;
                }

                m = _step.value;
                userActorId = m.userActorId;
                msStatusId = 'msStatus' + moduleSession.id + userActorId;
                _context.next = 21;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 21:
                msStatusCode = _context.sent.data.msStatusCode;

                console.log('\n\n ======== ViewSessionDetails.vue msStatusCode ========\n', msStatusCode, '\n =========== ');

                if (!(msStatusCode === 100)) {
                  _context.next = 30;
                  break;
                }

                _context.next = 26;
                return axios.get('/users/' + userActorId);

              case 26:
                user = _context.sent.data;

                viewPendingUploadFile.push(user);
                _context.next = 35;
                break;

              case 30:
                if (!(msStatusCode === 102)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 33;
                return axios.get('/users/' + userActorId);

              case 33:
                _user = _context.sent.data;

                viewPendingAttend.push(_user);

              case 35:
                _iteratorNormalCompletion = true;
                _context.next = 15;
                break;

              case 38:
                _context.next = 44;
                break;

              case 40:
                _context.prev = 40;
                _context.t0 = _context['catch'](13);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 44:
                _context.prev = 44;
                _context.prev = 45;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 47:
                _context.prev = 47;

                if (!_didIteratorError) {
                  _context.next = 50;
                  break;
                }

                throw _iteratorError;

              case 50:
                return _context.finish(47);

              case 51:
                return _context.finish(44);

              case 52:
                // console.log('\n\n ======== ViewSessionDetails.vue viewDetailedList ========\n',viewDetailedList, '\n =========== ');

                this.viewDetailedList[0].viewPendingUploadFile = viewPendingUploadFile;
                this.viewDetailedList[0].viewPendingAttend = viewPendingAttend;

                console.log('\n\n ======== ViewSessionDetails.vue store.viewDetailList ========\n', this.viewDetailedList[0], '\n =========== ');
                _context.next = 58;
                break;

              case 57:
                this.moduleSessionReturned = true;

              case 58:
                _context.next = 61;
                break;

              case 60:
                this.moduleSessionReturned = null;

              case 61:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 40, 44, 52], [45,, 47, 51]]);
      }));

      function searchModuleSession(_x) {
        return _ref.apply(this, arguments);
      }

      return searchModuleSession;
    }(),
    searchModuleSessionOfDay: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(searchKey) {
        var currentDateRaw, moduleName, searchResult, moduleSessionList, msCollection, usrCollection, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, moduleSession, moduleSessionId, managersList, userList;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('\n\n ====== searchKey ===== \n', searchKey, '\n ----------------');

                currentDateRaw = searchKey.currentDateRaw, moduleName = searchKey.moduleName;
                _context2.next = 4;
                return axios.post('/moduleSession/', {
                  currentDateRaw: currentDateRaw,
                  moduleName: moduleName
                });

              case 4:
                searchResult = _context2.sent.data;

                if (!searchResult) {
                  _context2.next = 60;
                  break;
                }

                if (!(searchResult.hasOwnProperty('moduleSessionList') && searchResult['moduleSessionList'].length > 0)) {
                  _context2.next = 56;
                  break;
                }

                console.log('\n\n ======= ViewSessionDetails <|-- searchModuleSessionOfDay() searchResult ======= \n', searchResult['moduleSessionList'], '\n --------------- ');

                moduleSessionList = searchResult.moduleSessionList; //["moduleSessionList"];

                msCollection = {};
                usrCollection = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 14;
                _iterator2 = _getIterator(moduleSessionList);

              case 16:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 32;
                  break;
                }

                moduleSession = _step2.value;
                moduleSessionId = moduleSession.id;


                msCollection[moduleSessionId] = {};
                msCollection[moduleSessionId]['moduleSession'] = moduleSession;

                _context2.next = 23;
                return this.getUserMsManagers(moduleSessionId);

              case 23:
                managersList = _context2.sent;

                console.log('\n\n ======= ViewSessionDetails <|-- searchModuleSessionOfDay() UserMsManager() ======= \n', managersList, '\n -------------');

                _context2.next = 27;
                return this.getApplicantList(moduleSessionId, managersList);

              case 27:
                userList = _context2.sent;

                usrCollection[moduleSessionId] = userList;

              case 29:
                _iteratorNormalCompletion2 = true;
                _context2.next = 16;
                break;

              case 32:
                _context2.next = 38;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t0 = _context2['catch'](14);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 38:
                _context2.prev = 38;
                _context2.prev = 39;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 41:
                _context2.prev = 41;

                if (!_didIteratorError2) {
                  _context2.next = 44;
                  break;
                }

                throw _iteratorError2;

              case 44:
                return _context2.finish(41);

              case 45:
                return _context2.finish(38);

              case 46:

                this.moduleSessionCollection = _extends({}, msCollection);
                this.applicantCollection = _extends({}, usrCollection);

                console.log('\n\n ======= ViewSessionDetails <|-- this.moduleSessionCollection =======\n', this.moduleSessionCollection, '\n -----------------');
                console.log('\n\n ======= ViewSessionDetails <|-- this.applicantCollection =======\n', this.applicantCollection, '\n -----------------');

                this.$store.commit('viewInfo/setViewInfoCollection', {
                  msCollection: msCollection,
                  usrCollection: usrCollection
                });

                console.log('\n\n ======================================================================= \n');

                console.log('\n\n ======= ViewSessionDetails <|-- $$ this.moduleSessionCollection =======\n', this.$store.state.viewInfo.moduleSessionCollection, '\n -----------------');

                console.log('\n\n ======= ViewSessionDetails <|-- $$ this.moduleSessionCollection =======\n', this.$store.state.viewInfo.userCollection, '\n -----------------');
                _context2.next = 58;
                break;

              case 56:
                this.$store.commit('viewInfo/setViewInfoCollection', {
                  msCollection: _extends({}, this.moduleSessionCollection),
                  usrCollection: _extends({}, this.applicantCollection)
                });
                alert('else internal -> No module session found');

              case 58:
                _context2.next = 62;
                break;

              case 60:
                this.$store.commit('viewInfo/setViewInfoCollection', {
                  msCollection: _extends({}, this.moduleSessionCollection),
                  usrCollection: _extends({}, this.applicantCollection)
                });
                alert('else external -> No module session found');

              case 62:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[14, 34, 38, 46], [39,, 41, 45]]);
      }));

      function searchModuleSessionOfDay(_x2) {
        return _ref2.apply(this, arguments);
      }

      return searchModuleSessionOfDay;
    }(),
    getUserMsManagers: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(moduleSessionId) {
        var managersList;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return axios.get('/userMsManager/' + moduleSessionId);

              case 2:
                managersList = _context3.sent.data;
                return _context3.abrupt('return', managersList);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getUserMsManagers(_x3) {
        return _ref3.apply(this, arguments);
      }

      return getUserMsManagers;
    }(),
    getApplicantList: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(moduleSessionId, managers) {
        var applicantList, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, m, userActorId, msStatusId, _data, msStatusCode, userMsStatus, remarkStatus, user, _user2, _user3, _user4, _user5, _user6, _user7, _user8, _user9, _user10;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                applicantList = {};
                // 100+

                applicantList['pendingUploadFile'] = [];
                applicantList['pendingAttend'] = [];
                // 200+
                applicantList['presentPendingGrade'] = [];
                applicantList['presentPass'] = [];
                applicantList['presentFailed'] = [];
                applicantList['Rejected'] = [];
                //applicantList['presentNA'] = [];
                // 300++
                applicantList['absent'] = [];
                //applicantList['reject'] = [];
                //applicantList['removed'] = [];
                // 1
                applicantList['cancelled'] = [];

                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 12;
                _iterator3 = _getIterator(managers);

              case 14:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context4.next = 78;
                  break;
                }

                m = _step3.value;
                userActorId = m.userActorId;
                msStatusId = 'msStatus' + moduleSessionId + userActorId;
                _context4.next = 20;
                return axios.post('/userMsStatus/userMsStatusCode', { msStatusId: msStatusId });

              case 20:
                _data = _context4.sent.data;
                msStatusCode = _data.msStatusCode;
                userMsStatus = _data.userMsStatus;

                console.log('\n\n ====== ViewSessionDetails <|-- getApplicantList() ====== \n', msStatusCode, '\n -----------');

                remarkStatus = userMsStatus.remark;

                if (!(msStatusCode == 100)) {
                  _context4.next = 30;
                  break;
                }

                _context4.next = 28;
                return axios.get('/users/' + userActorId);

              case 28:
                user = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['pendingUploadFile'].push({ user: user });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === user.companyName) {
                  applicantList['pendingUploadFile'].push({ user: user });
                }

              case 30:
                if (!(msStatusCode == 102)) {
                  _context4.next = 35;
                  break;
                }

                _context4.next = 33;
                return axios.get('/users/' + userActorId);

              case 33:
                _user2 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['pendingAttend'].push({ user: _user2 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user2.companyName) {
                  applicantList['pendingAttend'].push({ user: _user2 });
                }

              case 35:
                if (!(msStatusCode == 200)) {
                  _context4.next = 40;
                  break;
                }

                _context4.next = 38;
                return axios.get('/users/' + userActorId);

              case 38:
                _user3 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['presentPendingGrade'].push({ user: _user3 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user3.companyName) {
                  applicantList['presentPendingGrade'].push({ user: _user3 });
                }

              case 40:
                if (!(msStatusCode == 201)) {
                  _context4.next = 45;
                  break;
                }

                _context4.next = 43;
                return axios.get('/users/' + userActorId);

              case 43:
                _user4 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['presentPass'].push({ user: _user4 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user4.companyName) {
                  applicantList['presentPass'].push({ user: _user4 });
                }

              case 45:
                if (!(msStatusCode == 202)) {
                  _context4.next = 50;
                  break;
                }

                _context4.next = 48;
                return axios.get('/users/' + userActorId);

              case 48:
                _user5 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['presentFailed'].push({ user: _user5 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user5.companyName) {
                  applicantList['presentFailed'].push({ user: _user5 });
                }

              case 50:
                if (!(msStatusCode == 203)) {
                  _context4.next = 55;
                  break;
                }

                _context4.next = 53;
                return axios.get('/users/' + userActorId);

              case 53:
                _user6 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['Rejected'].push({ user: _user6 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user6.companyName) {
                  applicantList['Rejected'].push({ user: _user6 });
                }

              case 55:
                if (!(msStatusCode == 300)) {
                  _context4.next = 60;
                  break;
                }

                _context4.next = 58;
                return axios.get('/users/' + userActorId);

              case 58:
                _user7 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['absent'].push({ user: _user7 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user7.companyName) {
                  applicantList['absent'].push({ user: _user7 });
                }

              case 60:
                if (!(msStatusCode == 400)) {
                  _context4.next = 65;
                  break;
                }

                _context4.next = 63;
                return axios.get('/users/' + userActorId);

              case 63:
                _user8 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['reject'].push({ user: _user8 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user8.companyName) {
                  applicantList['reject'].push({ user: _user8 });
                }

              case 65:
                if (!(msStatusCode == 500)) {
                  _context4.next = 70;
                  break;
                }

                _context4.next = 68;
                return axios.get('/users/' + userActorId);

              case 68:
                _user9 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['removed'].push({ user: _user9 });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user9.companyName) {
                  applicantList['removed'].push({ user: _user9 });
                }

              case 70:
                if (!(msStatusCode == 1)) {
                  _context4.next = 75;
                  break;
                }

                _context4.next = 73;
                return axios.get('/users/' + userActorId);

              case 73:
                _user10 = _context4.sent.data;

                if (this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Trn') {
                  applicantList['cancelled'].push({ user: _user10, remarkStatus: remarkStatus });
                } else if (this.$store.state.authUser.flag === 'Con' && this.$store.state.authUser.companyName === _user10.companyName) {
                  applicantList['cancelled'].push({ user: _user10, remarkStatus: remarkStatus });
                }

              case 75:
                _iteratorNormalCompletion3 = true;
                _context4.next = 14;
                break;

              case 78:
                _context4.next = 84;
                break;

              case 80:
                _context4.prev = 80;
                _context4.t0 = _context4['catch'](12);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 84:
                _context4.prev = 84;
                _context4.prev = 85;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 87:
                _context4.prev = 87;

                if (!_didIteratorError3) {
                  _context4.next = 90;
                  break;
                }

                throw _iteratorError3;

              case 90:
                return _context4.finish(87);

              case 91:
                return _context4.finish(84);

              case 92:
                return _context4.abrupt('return', applicantList);

              case 93:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[12, 80, 84, 92], [85,, 87, 91]]);
      }));

      function getApplicantList(_x4, _x5) {
        return _ref4.apply(this, arguments);
      }

      return getApplicantList;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewSessionDetails.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/viewingInfo/ViewSessionDetails.vue
// module chunks = 2